window.Vue = require('vue');

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

Vue.component('ejecutivos-contacto', require('../../componentes/sitio/EjecutivosContactoProyecto').default);

Vue.config.productionTip = false;
Vue.config.devtools = false;

if(document.getElementById("vue-ejecutivos-contacto")){
    const contacto = new Vue({
        el: '#vue-ejecutivos-contacto',
    });
}
